var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tip)?_c('div',{staticClass:"d-flex mt-4 mb-n1"},[_c('v-spacer'),_c('v-card',{staticClass:"pl-4 results-card",attrs:{"flat":"","outlined":""}},[_c('anchor-results-display',{attrs:{"text":_vm.tip}})],1)],1):_vm._e(),_c('v-card',{class:{
      'tabs-card': !!_vm.tip,
      'mt-4': !_vm.tip,
    },attrs:{"flat":"","outlined":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }